import { CommonModule, CurrencyPipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormlyModule } from '@ngx-formly/core';
import { FormlySelectModule } from '@ngx-formly/core/select';
import { Button } from 'primeng/button';
import { Checkbox } from 'primeng/checkbox';
import { DatePickerModule } from 'primeng/datepicker';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { InputMaskModule } from 'primeng/inputmask';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputOtp } from 'primeng/inputotp';
import { InputTextModule } from 'primeng/inputtext';
import { RadioButton } from 'primeng/radiobutton';
import { Select } from 'primeng/select';
import { TextareaModule } from 'primeng/textarea';
import { FormlyWrapperFormField } from './form-field/form-field.wrapper';
import { FORMLY_CONFIG } from './formly.config';
import { FormlyButtonComponent } from './types/formly-button-component';
import { FormlyFieldCheckbox } from './types/formly-checkbox-component';
import { FormlyCountryComponent } from './types/formly-country-component';
import { FormlyCountryMultiSelectComponent } from './types/formly-country-multi-select-component';
import { FormlyDatePickerComponent } from './types/formly-datepicker-component';
import { FormlyFieldInput } from './types/formly-input-component';
import { FormlyOtpComponent } from './types/formly-otp-component';
import { FormlyPasswordComponent } from './types/formly-password-component';
import { FormlyPhoneComponent } from './types/formly-phone-component';
import { FormlyFieldRadio } from './types/formly-radio-component';
import { FormlyFieldSelect } from './types/formly-select-component';
import { FormlyTextareaComponent } from './types/formly-textarea-component';
import { FormlyEmailWithOtpComponent } from './types/formly-email-with-otp-component';
import { Tooltip } from 'primeng/tooltip';
import { FormlyLabelWrapper } from './wrappers/formly-label-wrapper-component';
import { FormlyMultiSelectFieldComponent } from './types/formly-multi-select-component';
import { MultiSelectModule } from 'primeng/multiselect';
import { InputIconModule } from 'primeng/inputicon';
import { IconFieldModule } from 'primeng/iconfield';
import { FormlyFieldApiSelect } from './types/formly-api-select-component';
import { FormlyJsonComponent } from './types/formly-json-component';
import { FormlyUsStateComponent } from './types/formly-us-state-component';
import { FormlyFileComponent } from './types/formly-file-component';
import { FileUploadModule } from 'primeng/fileupload';

const formComponents: any = [
  FormlyWrapperFormField,
  FormlyFieldInput,
  FormlyFieldCheckbox,
  FormlyFieldRadio,
  FormlyFieldSelect,

  // Mine
  FormlyMultiSelectFieldComponent,
  FormlyPasswordComponent,
  FormlyCountryComponent,
  FormlyCountryMultiSelectComponent,
  FormlyDatePickerComponent,
  FormlyTextareaComponent,
  FormlyPhoneComponent,
  FormlyOtpComponent,
  FormlyButtonComponent,
  FormlyEmailWithOtpComponent,
  FormlyFieldApiSelect,
  FormlyJsonComponent,
  FormlyUsStateComponent,
  FormlyFileComponent,

  //Wrappers
  FormlyLabelWrapper,
];

@NgModule({
  declarations: formComponents,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FormlySelectModule,
    InputTextModule,
    Select,
    RadioButton,
    Checkbox,
    InputMaskModule,
    InputNumberModule,
    InputGroupAddonModule,
    InputGroupModule,
    DatePickerModule,
    InputOtp,
    TextareaModule,
    Button,
    Tooltip,
    MultiSelectModule,
    InputIconModule,
    IconFieldModule,
    FileUploadModule,
    FormlyModule.forRoot(FORMLY_CONFIG),
  ],
  exports: [
    ReactiveFormsModule,
    TextareaModule,
    FormsModule,
    FormlyModule,
    ...formComponents,
  ],
  providers: [CurrencyPipe],
})
export class FormModule {}
